// extracted by mini-css-extract-plugin
export default {"noFollowers":"NoFollowing_noFollowers__FQVTe","text":"NoFollowing_text__tSbdr"};